import autodesk360 from "../../assets/workshop/auto.jpg";
import nextgenai from "../../assets/workshop/nextgen.jpg";

// Import PDF files for each workshop
import autodesk from "../../assets/pdfs/auto Desk fusion 360.pdf";
import nextgen from "../../assets/pdfs/Next Gen Robotics L.pdf";

export const WorkShopJson = [
  {
    title: "NEXT-GEN ROBOTICS WITH AI AND NODEMCU",
    price: "Workshop: ₹ 1000/-",
    Accommodation: "Accommodation: ₹ 400/-",
    highlight: "Highlights",
    description: [
      "Build a robot from scratch using NodeMCU, motors, and servos.",
      "Control the robot using Python, integrating motor control and AI-based command processing.",
      "Develop a Python application that communicates with the robot and displays live video feed.",
      "Implement intent recognition using LLM APIs (e.g., OpenAI GPT or other NLP models).",
      "Understand and implement key concepts in robotics and AI, such as HTTP protocols and client-server architecture.",
    ],
    image: nextgenai,
    pdfLink: nextgen,
  },
  {
    title: "AUTODESK FUSION 360 WITH 3D PRINTING",
    price: "Workshop: ₹ 1000/-",
    Accommodation: "Accommodation: ₹ 400/-",
    highlight: "Highlights",
    description: [
      "Introduce students to CAD fundamentals and technical drawing concepts.",
      "Develop skills in 3D modeling, sketching, and parametric design.",
      "Enable participants to create assemblies and conduct motion studies.",
      "Provide exposure to sheet metal, surface modeling, and rendering.",
      "Guide participants to complete a professional design project with documentation.",
      "Fusion 360 CAD models were 3D printed, giving participants valuable practical hands-on experience.",
      
    ],
    image: autodesk360,
    pdfLink: autodesk,
  },
];
